// extracted by mini-css-extract-plugin
module.exports = {"base":"TrialDetailsHyperparameters_base__1XxMZ"};